import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../Services/Api";

// initialize client IP from local storage
const clientIP = localStorage.getItem('rfc_client_ip')
    ? localStorage.getItem('rfc_client_ip')
    : null

const initialState = {
    loading: false,
    data: [],
    error: ''
}

// fetch data from api
export const fetchPastEvents = createAsyncThunk('fetchPastEvents', async (searchObject) => {
    return api
        // .get(`crypto-events/all?per_page=10&direction=DESC&sort_key=id&page=1`)
        // .get(`crypto-events/all?per_page=${10*searchObject.pageNumber}&direction=ASC&sort_key=start_datetime&page=1`)
        .get(`crypto-events/past?per_page=10&direction=DESC&sort_key=start_datetime&page=${searchObject.pageNumber}`)
        .then((response) => response.data.payload)
})

export const pastEventsSlice = createSlice({
    name: "pastEvents",
    initialState,
    extraReducers: (builder) => {
        builder.addCase(fetchPastEvents.pending, (state) => {
            state.loading = true
        })
        builder.addCase(fetchPastEvents.fulfilled, (state, action) => {
            state.loading = false
            state.data = action.payload
            state.error = ''
        })
        builder.addCase(fetchPastEvents.rejected, (state, action) => {
            state.loading = false
            state.data = []
            state.error = action.error.message
        })
    }
});

export default pastEventsSlice.reducer